import { render, staticRenderFns } from "./KOLs.vue?vue&type=template&id=52da3a87&scoped=true"
import script from "./KOLs.vue?vue&type=script&lang=js"
export * from "./KOLs.vue?vue&type=script&lang=js"
import style0 from "./KOLs.vue?vue&type=style&index=0&id=52da3a87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da3a87",
  null
  
)

export default component.exports